import storage from "store";
import {ACCESS_TOKEN, TENANT, TOKEN_NAME} from "@/store/mutation-types";

const commonMixin = {
  computed: {
    clientHost() {
      return ''
    },
    apiUrl() {
      return process.env.VUE_APP_API_BASE_URL;
    },
    tokenHeaders() {
      const tenant = storage.get(TENANT)
      const tokenName = storage.get(TOKEN_NAME)
      const token = storage.get(ACCESS_TOKEN)
      const headers = {}
      headers[tokenName] = token
      headers['tenant'] = tenant
      return headers
    },
    filePreview() {
      return (id) => {
        return `${process.env.VUE_APP_API_BASE_URL}/file/preview?key=${id}&tenant=${storage.get(TENANT)}`;
      };
    },
    fileDownload() {
      return (id) => {
        return `${process.env.VUE_APP_API_BASE_URL}/file/download?key=${id}&tenant=${storage.get(TENANT)}`;
      };
    },
    uploadFileUrl() {
      return `${process.env.VUE_APP_API_BASE_URL}/file/upload`;
    }
  },
};

const mixinValidator = {
  methods: {
    /**
     *  :rules="[{validatorIdCard, message: '身份证号码格式错误！'}]"
     * 身份证验证
     */
    validatorIdCard(rule, val) {
      const card15 =
        /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/;
      const card18 =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      return card15.test(val) || card18.test(val)
        ? Promise.resolve()
        : Promise.reject("身份证格式有误");
    },
    /**
     * :rules="[{validatorEmail, message: '邮箱格式错误！'}]"
     * 邮箱验证
     */
    validatorEmail(rule, val) {
      if (!val) {
        return Promise.resolve();
      } else {
        const email =
          /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        return email.test(val)
          ? Promise.resolve()
          : Promise.reject("电子邮箱格式有误");
      }
    },
    /**
     *  :rules="[{validatorMobilePhone, message: '手机号码号码格式错误！'}]"
     * 手机号码验证
     */
    validatorMobilePhone(rule, val) {
      const mobilePhone = /^1[3456789]\d{9}$/;
      return mobilePhone.test(val)
        ? Promise.resolve()
        : Promise.reject("手机号码格式有误！");
    },
    /**
     *  :rules="[{validatorPhone, message: '固话格式错误！'}]"
     * 固话验证
     */
    validatorPhone(rule, val) {
      const phone = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
      return phone.test(val)
        ? Promise.resolve()
        : Promise.reject("电话格式有误");
    },

    /**
     * 密码格式校验
     * @param {} rule
     * @param {*} val
     */
    validatorPassword(rule, val) {
      const reg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z._~!@#$^&*]+$)(?![a-z0-9]+$)(?![a-z._~!@#$^&*]+$)(?![0-9._~!@#$^&*]+$)[a-zA-Z0-9._~!@#$^&*]{8,16}$/;
      return reg.test(val)
        ? Promise.resolve()
        : Promise.reject(
            "新密码不符合规则：长度8—16位，且必须包含大、小写字母及数字"
          );
    },
  },
};

export { mixinValidator, commonMixin };
